import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import { AuthProvider } from './contexts/AuthContext';
import { ChatProvider } from './contexts/ChatContext';
import CardNav from './components/CardNav';
import Footer from './components/Footer';
import ChatWidget from './components/ChatWidget';
import Home from './pages/Home';
import Servers from './pages/Servers';
import Market from './pages/Areas';
import Scripts from './pages/Scripts';
import ServerGuide from './pages/ServerGuide';
import Rules from './pages/Rules';
import TermsOfService from './pages/TermsOfService';
import PrivacyPolicy from './pages/PrivacyPolicy';
import Login from './pages/Login';
import Register from './pages/Register';
import Profile from './pages/Profile';
import AdminPanel from './pages/AdminPanel';
import Contact from './pages/Contact';
import FAQ from './pages/FAQ';
import SponsorApply from './pages/SponsorApply';
import Sponsors from './pages/Sponsors';
import NotFound from './pages/NotFound';

function App() {
  return (
    <AuthProvider>
      <ChatProvider>
        <Router>
          <div className="min-h-screen bg-dark-900 flex flex-col">
            <CardNav />
            <main className="flex-1">
              <Routes>
                <Route path="/" element={<Home />} />
                <Route path="/servers" element={<Servers />} />
                <Route path="/market" element={<Market />} />
                <Route path="/sponsors" element={<Sponsors />} />
                <Route path="/scripts" element={<Scripts />} />
                <Route path="/guide" element={<ServerGuide />} />
                <Route path="/guide/faq" element={<FAQ />} />
            <Route path="/sponsors/apply" element={<SponsorApply />} />
                <Route path="/rules" element={<Rules />} />
                <Route path="/terms-of-service" element={<TermsOfService />} />
                <Route path="/privacy-policy" element={<PrivacyPolicy />} />
                <Route path="/login" element={<Login />} />
                <Route path="/register" element={<Register />} />
                <Route path="/profile" element={<Profile />} />
                <Route path="/admin" element={<AdminPanel />} />
                <Route path="/contact" element={<Contact />} />
                <Route path="*" element={<NotFound />} />
              </Routes>
            </main>
            <Footer />
            <ChatWidget />
          </div>
        </Router>
      </ChatProvider>
    </AuthProvider>
  );
}

export default App;
